(() => {
  const FORM_NEWSLETTER = document.forms["newsletter-footer"];
  const MESSAGESCONTAINER = document.querySelector('.message-newsletter');
  const SUCCESSSTATUS = 200;
  const ZEROABSOLUTE = 0;
  const BLANKVALUE = '';
  const MESSAGESUCCESSFULLY =
    `<div class="has-valid-email">Thank you for subscribing</div>`;
  const MESSAGEDANGEROUS =
    `<div class="alert-warning">Sorry, your form isn't sent. check again or you can check later.</div>`;
  const MESSAGEEMPTYFIELDS = `<div class="alert-warning">Your email is required!</div>`;

  //custom show alert
  function SHOWALERT(MESSAGE, SHOW, DELAY) {
    MESSAGESCONTAINER.innerHTML = MESSAGE;
    if (SHOW) {
      MESSAGESCONTAINER.classList.add('show');
    }
    setTimeout(() => {
      MESSAGESCONTAINER.innerHTML = BLANKVALUE;
      if (SHOW) {
        MESSAGESCONTAINER.classList.remove('show');
      }
    }, DELAY);
  }

  function emailIsValid(email) {
    return /\S+@\S+\.\S+/.test(email)
  }
  /* SCROLL EMPTY FIELDS */

  //NOT EMPTY FIELDS METHOD
  function notEmptyfields() {
    let emptyS = 0;
    let CONDITIONEMPTY = false;
    document.querySelectorAll('.contact-form input[required]').forEach((field) => {
      if (field.attributes.TYPE.value === 'email') {
        if (emailIsValid(field.value) === false) {
          emptyS++;
        }

      }

      if (field.value == BLANKVALUE) {
        emptyS++;
        field.classList.add('has-error');

      } else {
        if (field.attributes.TYPE.value !== 'email') {
          field.classList.remove('has-error');
        }
      }
    });

    return emptyS;
  }

  //METHOD FOR SEND REQUEST
  async function sendDATA(URL, DATA, TYPE) {
    return await fetch(URL, {
      method: TYPE,
      body: DATA
    });
  }

  //PROCESS
  async function METHODOFSENDDATAandATEMPMODAL(FORM) {
      FORM_NEWSLETTER.submit();
  }


  function initNewsletter(event) {
    event.preventDefault();
    const DATA = new FormData(FORM_NEWSLETTER);
    if (notEmptyfields() == ZEROABSOLUTE) {
      METHODOFSENDDATAandATEMPMODAL(DATA);
    } else {
      SHOWALERT(MESSAGEEMPTYFIELDS, true, 4000);
    }
  }

  document.getElementById('btn_send').addEventListener('click', (e) => {
    e.preventDefault();
    initNewsletter(e);
  });

  document.getElementById('auto_send').addEventListener('keydown', (e) => {
    if (e.key == "Enter") {
      e.preventDefault();
      initNewsletter(e);
    }
  });
})()
